import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useAppDispatch } from '@store/hooks';
// import { fetchUnpaidInvoices } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';
import { fetchUnpaidTransactions } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';

import { type UnPaymentSchedulesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
// import { getUnApplyPrepaymentsListByPeopleId } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
import { getUnApplyPrepaymentsListByPeopleId } from '@store/Finance/AR/ArReceipts/ArReceiptsSlice';



export const ApplyPreReceiptComponent: React.FC<{
  formik: any;
  onClose: () => void;
  OperatingUnitOptions: any[];
  treeCustomerData: any[];
}> = ({ formik, onClose, OperatingUnitOptions, treeCustomerData }) => {
  const { values, setFieldValue } = formik;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // State خاص بالمكون
  const [preReceiptList, setPreReceiptList] = useState<any[]>([]);
  const [transactions, setTransactions] = useState<any[]>([]);
  const [selectedPrereceipt, setSelectedPrereceipt] = useState<any>(null);
  const [appliedTransactions, setAppliedTransactions] = useState<{ReceiptScheduleId: string, amount: number}[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  const resetState = () => {
    setPreReceiptList([]);
    setTransactions([]);
    setSelectedPrereceipt(null);
    setAppliedTransactions([]);
    setFetchError(null);
    setIsLoading(false);
  };

  const handleGetUnpaidTransactions = async () => {
    if (!values.organizationId || !values.peopleId) return;

    setIsLoading(true);
    setFetchError(null);

    try {
      const [prereceiptResult, standardResult] = await Promise.all([
        dispatch(getUnApplyPrepaymentsListByPeopleId(values.peopleId)).unwrap(),
        dispatch(
          fetchUnpaidTransactions({
            peopleId: values.peopleId,
            organizationId: values.organizationId,
            TransactionType: 'Standard'
          })
        ).unwrap()
      ]);

      let prereceiptData: any[] = [];
      let standardData: any[] = [];
      
      if (prereceiptResult.succeeded) {
        prereceiptData = prereceiptResult.data.map((item: any) => ({
          amount: item.amount,
          amountUnApply: item.amountUnApply,
          code: item.code,
          id: item.id,
          depositDate: item.depositDate
        }));
        setPreReceiptList(prereceiptData);
      }

      if (standardResult.succeeded) {
        standardData = standardResult.data.map((invoice: any) => ({
          ...invoice,
          invoiceType: 'Standard',
          id: invoice.arReceiptScheduleId
        }));
        setTransactions(standardData);
      }

      if (!prereceiptResult.succeeded || prereceiptData.length === 0) {
        setFetchError('لا توجد دفعات مقدمة للمقاصة');
      } else if (!standardResult.succeeded || standardData.length === 0) {
        setFetchError('لا توجد فواتير عادية للمقاصة');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setFetchError('فشل في جلب البيانات');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrepaymentSelection = (prepayment: any) => {
    setSelectedPrereceipt(prepayment);
  };

  const handleAppliedAmountChange = (transactionId: string, amount: number) => {
    
    const transaction = transactions.find(inv => inv.arReceiptScheduleId === transactionId);
    if (!transaction) return;

    const maxAmount = Math.min(transaction.remainingAmount, selectedPrereceipt?.amountUnApply || 0);
    const finalAmount = Math.max(0, Math.min(amount, maxAmount));

    setAppliedTransactions(prev => {
      const filtered = prev.filter(item => item.ReceiptScheduleId !== transactionId);
      
      if (finalAmount > 0) {
        return [...filtered, { ReceiptScheduleId: transactionId, amount: finalAmount }];
      }
      
      return filtered;
    });
  };

  const handleSubmit = () => {
    if (!selectedPrereceipt) {
      alert('يجب اختيار دفعة مقدمة واحدة');
      return;
    }

    if (appliedTransactions.length === 0) {
      alert('يجب إدخال مبالغ للفواتير العادية');
      return;
    }

    if (!isFormValid) {
      return;
    }

    const totalAppliedAmount = appliedTransactions.reduce((sum, item) => sum + item.amount, 0);
    const prereceiptAmount = selectedPrereceipt.amountUnApply;

    if (totalAppliedAmount > prereceiptAmount) {
      alert(
        `المبلغ الإجمالي المطبق (${totalAppliedAmount.toLocaleString()}) لا يمكن أن يتجاوز رصيد الدفعة المقدمة (${prereceiptAmount.toLocaleString()})`
      );
      return;
    }


            
        

    // إعداد بيانات الفواتير العادية (كهدف)
    const appliedTransactionsData = appliedTransactions.map(({ ReceiptScheduleId, amount }) => {
      const transaction = transactions.find(inv => inv.arReceiptScheduleId === ReceiptScheduleId);
      return {
        id: null,
        arReceiptScheduleId: transaction.arReceiptScheduleId,
        transactionNum: transaction.transactionNum,
        transactionDate: transaction.transactionDate,
        dueDate: transaction.dueDate,
        transactionAmount: transaction.transactionAmount,
        schadualAmount: transaction.schadualAmount || 0,
        amount: amount,
        actualRemainingAmount: transaction.remainingAmount,
        transactionType: 'Standard'
      };
    });

    formik?.setFieldValue('scheduleList', appliedTransactionsData);
    formik?.setFieldValue('preReceiptId', selectedPrereceipt.id);

    onClose();
  };

  // 🔹 مجموع المبالغ المطبقة على الفواتير القياسية
  const totalAppliedAmount = appliedTransactions.reduce((sum, item) => sum + item.amount, 0);

  // 🔹 المبلغ الكامل للدفعة المقدمة
  const prepaymentTotal = selectedPrereceipt?.amount || 0;

  // 🔹 المبلغ غير المطبق (المتبقي حالياً في النظام قبل التطبيق الجديد)
  const prepaymentUnapplied = selectedPrereceipt?.amountUnApply || 0;

  // 🔹 المبلغ المتبقي بعد التطبيق الحالي
  const remainingPrepaymentAmount = prepaymentUnapplied - totalAppliedAmount;

  // 🔹 التحقق من أن المستخدم لم يتجاوز المبلغ المتاح
  const isAmountValid = totalAppliedAmount <= prepaymentUnapplied;

  // 🔹 تحقق شامل من صلاحية النموذج
  const isFormValid = !!selectedPrereceipt && appliedTransactions.length > 0 && isAmountValid;


  // console.log(transactions);
  // console.log(appliedTransactions);
  

  return (
    <>
      <div className='row g-3 mb-4'>
        {/* العميل والوحدة التشغيلية */}
        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>العميل</label>
            <TreeSelect
              showSearch
              className='w-100'
              treeLine
              placeholder='اختر العميل'
              allowClear
              value={values.peopleId}
              onChange={option => {
                resetState();
                formik.setFieldValue('peopleId', option === null ? null : option);
              }}
              treeData={treeCustomerData}
              treeNodeFilterProp='title'
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </div>
        </div>

        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>الوحدة التشغيلية</label>
            <Select
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
              onChange={(option: any) => {
                resetState();
                setFieldValue('organizationId', option === null ? null : option.value);
              }}
              placeholder='اختر الوحدة التشغيلية'
              className='react-select-container'
              classNamePrefix='react-select'
            />
          </div>
        </div>

        <div className='col-lg-2'>
          <div className='form-group h-100 d-flex flex-column justify-content-end'>
            <button
              disabled={isLoading || !values.organizationId || !values.peopleId}
              type='button'
              className='btn btn-sm btn-outline-theme w-100 py-2'
              onClick={handleGetUnpaidTransactions}
            >
              {isLoading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2'></span>
                  جاري التحميل...
                </>
              ) : (
                <>
                  <i className='fas fa-download me-2'></i>
                  جلب البيانات
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {fetchError && (
        <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
          <i className='fas fa-exclamation-triangle me-2'></i>
          <div>{fetchError}</div>
        </div>
      )}

      {/* الدفعات المقدمة */}
      {preReceiptList.length > 0 && (
        <div className='row mb-4'>
          <div className='col-12'>
            <Card className='border-warning'>
              <CardHeader className='bg-warning bg-opacity-10 border-warning d-flex justify-content-between align-items-center py-3'>
                <h6 className='mb-0'>
                  <i className='fas fa-hand-holding-usd me-2 text-warning'></i>
                  اختر الدفعة المقدمة
                </h6>
                <span className='badge bg-warning'>{preReceiptList.length} دفعة متاحة</span>
              </CardHeader>

              <CardBody className='p-0'>
                <div className='list-group list-group-flush'>
                  {preReceiptList.map((item, index) => (
                    <div
                      key={item.id}
                      className={`list-group-item list-group-item-action border-bottom ${
                        selectedPrereceipt?.id === item.id
                          ? 'bg-warning bg-opacity-10 border-warning border-1'
                          : 'border-light'
                      }`}
                      onClick={() => handlePrepaymentSelection(item)}
                      style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                    >
                      <div className='d-flex justify-content-between align-items-start'>
                        <div className='d-flex align-items-start flex-grow-1'>
                          <div className='form-check mt-1 me-3'>
                            <input
                              type='radio'
                              className='form-check-input'
                              name='prepaymentInvoice'
                              checked={selectedPrereceipt?.id === item.id}
                              onChange={() => handlePrepaymentSelection(item)}
                            />
                          </div>
                          <div className='flex-grow-1'>
                            <div className='d-flex align-items-center mb-2'>
                              <h6 className='mb-0 me-3'>{item.code}</h6>
                              <span className='badge bg-light small'>
                                <i className='fas fa-calendar me-1'></i>
                                {item.depositDate?.split('T')[0]}
                              </span>
                            </div>

                            <div className='row g-3'>
                              <div className='col-auto'>
                                <div className='d-flex flex-column'>
                                  <small className='mb-1'>المبلغ الكامل</small>
                                  <span className='fw-bold fs-6'>
                                    {Number(item.amount).toLocaleString()}
                                  </span>
                                </div>
                              </div>

                              <div className='col-auto'>
                                <div className='vr h-100'></div>
                              </div>

                              <div className='col-auto'>
                                <div className='d-flex flex-column'>
                                  <small className='text-muted mb-1'>المبلغ المتبقي</small>
                                  <span className='fw-bold text-warning fs-6'>
                                    {Number(item.amountUnApply).toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='text-end ms-3'>
                          <div className='d-flex flex-column align-items-end'>
                            <span
                              className={`badge fs-6 ${
                                selectedPrereceipt?.id === item.id ? 'bg-dark text-warning' : 'bg-warning'
                              }`}
                            >
                              {Number(item.amountUnApply).toLocaleString()}
                            </span>
                            <small className='text-muted mt-1'>
                              متبقي من {Number(item.amount).toLocaleString()}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      )}

      {/* ملخص المقاصة */}
      {(selectedPrereceipt || appliedTransactions.length > 0) && (
        <div className={`alert ${isAmountValid ? 'alert-success' : 'alert-warning'} mb-4`}>
          <div className='row text-center'>
            <div className='col-md-3 border-end'>
              <div className='small text-muted'>رصيد الدفعة المقدمة</div>
              <div className='h5 fw-bold text-warning'>{prepaymentTotal.toLocaleString()}</div>
              {selectedPrereceipt && <small className='text-muted'>دفعة: {selectedPrereceipt.code}</small>}
            </div>
            <div className='col-md-3 border-end'>
              <div className='small text-muted'>المبلغ المطبق</div>
              <div className='h5 fw-bold text-primary'>{totalAppliedAmount.toLocaleString()}</div>
              <small className='text-muted'>على {appliedTransactions.length} فاتورة</small>
            </div>
            <div className='col-md-3 border-end'>
              <div className='small text-muted'>الرصيد المتبقي</div>
              <div className={`h5 fw-bold ${remainingPrepaymentAmount > 0 ? 'text-success' : 'text-danger'}`}>
                {remainingPrepaymentAmount.toLocaleString()}
              </div>
            </div>
            <div className='col-md-3'>
              <div className='small text-muted'>الحالة</div>
              <div className={`h6 fw-bold ${isAmountValid ? 'text-success' : 'text-danger'}`}>
                {isAmountValid ? 'المبلغ ضمن الحدود' : 'المبلغ تجاوز الرصيد'}
              </div>
            </div>
          </div>
          {!isAmountValid && (
            <div className='mt-2 text-center'>
              <i className='fas fa-exclamation-triangle me-2'></i>
              المبلغ المطبق لا يمكن أن يتجاوز رصيد الدفعة المقدمة
            </div>
          )}
        </div>
      )}

      {/* جدول الفواتير العادية */}
      {transactions.length > 0 && selectedPrereceipt && (
        <div className='row'>
          <div className='col-12'>
            <Card className='border-primary'>
              <CardHeader className='bg-primary bg-opacity-35 text-white d-flex justify-content-between align-items-center'>
                <h6 className='mb-0'>
                  <i className='fas fa-file-invoice me-2'></i>
                  الفواتير العادية - أدخل المبالغ المطبقة من الدفعة المقدمة
                </h6>
              </CardHeader>
              <CardBody className='p-0'>
                <div className='table-responsive'>
                  <table className='table table-hover mb-0'>
                    <thead className='table-primary'>
                      <tr>
                        <th className='text-center small'>رقم الفاتورة</th>
                        <th className='text-center small'>التاريخ</th>
                        <th className='text-center small'>تاريخ الاستحقاق</th>
                        <th className='text-center small'>المبلغ الأصلي</th>
                        <th className='text-center small'>الرصيد المتبقي</th>
                        <th className='text-center small'>المبلغ المطبق</th>
                        <th className='text-center small'>الرصيد بعد التطبيق</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((transaction, index) => {
                        const appliedItem = appliedTransactions.find(item => item.ReceiptScheduleId === transaction.arReceiptScheduleId);
                        const appliedAmount = appliedItem?.amount || 0;
                        const remainingBalance = transaction.remainingAmount - appliedAmount;
                        const balanceAfter = Math.max(0, remainingBalance);
                        const isOverdue = new Date(transaction.dueDate) < new Date();

                        return (
                          <tr
                            key={transaction.arReceiptScheduleId}
                            className={appliedAmount > 0 ? 'table-active bg-primary bg-opacity-10' : ''}
                          >
                            <td className='text-center align-middle'>
                              <div>
                                <div className='fw-bold'>{transaction.transactionNum}</div>
                                <small className='text-muted'>دفعة: {transaction.receiptNum}</small>
                              </div>
                            </td>
                            <td className='text-center align-middle'>
                              {transaction.transactionDate?.split('T')[0]}
                            </td>
                            <td className='text-center align-middle'>
                              <div className={isOverdue ? 'text-danger fw-bold' : 'text-dark'}>
                                {transaction.dueDate?.split('T')[0]}
                                {isOverdue && (
                                  <div>
                                    <small className='text-danger'>متأخرة</small>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className='text-center align-middle text-muted'>
                              {Number(transaction.transactionAmount).toLocaleString()}
                            </td>
                            <td className='text-center align-middle'>
                              <span className={`fw-bold ${transaction.remainingAmount > 0 ? 'text-primary' : 'text-success'}`}>
                                {Number(transaction.remainingAmount).toLocaleString()}
                              </span>
                            </td>
                            <td className='text-center align-middle'>
                              <Form.Control
                                type='number'
                                value={appliedAmount || ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  const value = parseFloat(e.target.value) || 0;
                                  handleAppliedAmountChange(transaction.arReceiptScheduleId, value);
                                }}
                                onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                  const value = parseFloat(e.target.value) || 0;
                                  handleAppliedAmountChange(transaction.arReceiptScheduleId, value);
                                }}
                                step='0.01'
                                min='0'
                                max={Math.min(transaction.remainingAmount, selectedPrereceipt?.amountUnApply || 0)}
                                className='text-center w-100 fw-bold border-warning '
                                // style={{ width: '130px' }}
                                placeholder='0.00'
                              />
                            </td>
                            <td className='text-center align-middle'>
                              <span className={`fw-bold ${balanceAfter > 0 ? 'text-warning' : 'text-success'}`}>
                                {balanceAfter.toLocaleString()}
                                {balanceAfter === 0 && (
                                  <div>
                                    <small className='text-success'>مستنفذ</small>
                                  </div>
                                )}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
              <CardFooter className='d-flex justify-content-between align-items-center'>
                <div className='text-muted small'>
                  {appliedTransactions.length} / {transactions.length} فاتورة مختارة
                </div>
                <div className='fw-bold text-primary'>الإجمالي المطبق: {totalAppliedAmount.toLocaleString()}</div>
              </CardFooter>
            </Card>
          </div>
        </div>
      )}

      <div className='border-top mt-4 pt-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <div></div>
          <div className='d-flex'>
            <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
              <i className='fas fa-check-circle me-2'></i>
              استمرار
            </button>
            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={() => navigate('/AR/ArReceipts', { replace: true })}
            >
              <i className='fas fa-times me-2'></i>
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </>
  );
};





// export const ApplyPreReceiptComponent: React.FC<{
//   formik: any;
//   onClose: () => void;
//   OperatingUnitOptions: any[];
//   treeCustomerData: any[];
// }> = ({ formik, onClose, OperatingUnitOptions, treeCustomerData }) => {
//   const { values, setFieldValue } = formik;
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   // State خاص بالمكون
//   const [preReceiptList, setPreReceiptList] = useState<any[]>([]);
//   const [transactions, setTransactions] = useState<any[]>([]);
//   const [selectedPrereceipt, setSelectedPrereceipt] = useState<any>(null);
//   const [appliedTransactions, setAppliedTransactions] = useState<{invoiceId: string, amount: number}[]>([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [fetchError, setFetchError] = useState<string | null>(null);

//   const resetState = () => {
//     setPreReceiptList([]);
//     setTransactions([]);
//     setSelectedPrereceipt(null);
//     setAppliedTransactions([]);
//     setFetchError(null);
//     setIsLoading(false);
//   };

//   const handleGetUnpaidTransactions = async () => {
//     if (!values.organizationId || !values.peopleId) return;

//     setIsLoading(true);
//     setFetchError(null);

//     try {
//       const [prereceiptResult, standardResult] = await Promise.all([
//         dispatch(getUnApplyPrepaymentsListByPeopleId(values.peopleId)).unwrap(),
//         dispatch(
//           fetchUnpaidTransactions({
//             peopleId: values.peopleId,
//             organizationId: values.organizationId,
//             TransactionType: 'Standard'
//           })
//         ).unwrap()
//       ]);

//       let prereceiptData: any[] = [];
//       let standardData: any[] = [];
      
//       if (prereceiptResult.succeeded) {
//         prereceiptData = prereceiptResult.data.map((item: any) => ({
//           amount: item.amount,
//           amountUnApply: item.amountUnApply,
//           code: item.code,
//           id: item.id,
//           depositDate: item.depositDate
//         }));
//         setPreReceiptList(prereceiptData);
//       }

//       if (standardResult.succeeded) {
//         standardData = standardResult.data.map((invoice: any) => ({
//           ...invoice,
//           invoiceType: 'Standard',
//           id: invoice.arReceiptScheduleId
//         }));
//         setTransactions(standardData);
//       }

//       if (!prereceiptResult.succeeded || prereceiptData.length === 0) {
//         setFetchError('لا توجد دفعات مقدمة للمقاصة');
//       } else if (!standardResult.succeeded || standardData.length === 0) {
//         setFetchError('لا توجد فواتير عادية للمقاصة');
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setFetchError('فشل في جلب البيانات');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handlePrepaymentSelection = (prepayment: any) => {
//     setSelectedPrereceipt(prepayment);
//   };

//   const handleAppliedAmountChange = (invoiceId: string, amount: number) => {
//     const invoice = transactions.find(inv => inv.arReceiptScheduleId === invoiceId);
//     if (!invoice) return;

//     const maxAmount = Math.min(invoice.remainingAmount, selectedPrereceipt?.amountUnApply || 0);
//     const finalAmount = Math.max(0, Math.min(amount, maxAmount));

//     setAppliedTransactions(prev => {
//       // إزالة العنصر إذا كان موجوداً
//       const filtered = prev.filter(item => item.invoiceId !== invoiceId);
      
//       // إضافة العنصر إذا كان المبلغ أكبر من صفر
//       if (finalAmount > 0) {
//         return [...filtered, { invoiceId, amount: finalAmount }];
//       }
      
//       return filtered;
//     });
//   };

//   const handleSubmit = () => {
//     if (!selectedPrereceipt) {
//       alert('يجب اختيار دفعة مقدمة واحدة');
//       return;
//     }

//     if (appliedTransactions.length === 0) {
//       alert('يجب إدخال مبالغ للفواتير العادية');
//       return;
//     }

//     if (!isFormValid) {
//       return;
//     }

//     const totalAppliedAmount = appliedTransactions.reduce((sum, item) => sum + item.amount, 0);
//     const prepaymentAmount = selectedPrereceipt.amountUnApply;

//     if (totalAppliedAmount > prepaymentAmount) {
//       alert(
//         `المبلغ الإجمالي المطبق (${totalAppliedAmount.toLocaleString()}) لا يمكن أن يتجاوز رصيد الدفعة المقدمة (${prepaymentAmount.toLocaleString()})`
//       );
//       return;
//     }

//     // إعداد بيانات الفواتير العادية (كهدف)
//     const appliedInvoicesData = appliedTransactions.map(({ invoiceId, amount }) => {
//       const invoice = transactions.find(inv => inv.arReceiptScheduleId === invoiceId);
//       return {
//         id: null,
//         arReceiptScheduleId: invoice.arReceiptScheduleId,
//         invoiceNum: invoice.invoiceNum,
//         invoiceDate: invoice.invoiceDate,
//         dueDate: invoice.dueDate,
//         invoiceAmount: invoice.invoiceAmount,
//         schadualAmount: invoice.schadualAmount || 0,
//         amount: amount,
//         actualRemainingAmount: invoice.remainingAmount,
//         invoiceType: 'Standard'
//       };
//     });

//     formik?.setFieldValue('scheduleList', appliedInvoicesData);
//     formik?.setFieldValue('prePaymentId', selectedPrereceipt.id);

//     onClose();
//   };

//   const columns = [
//     { title: 'رقم الفاتورة', key: 'invoiceNum' },
//     { title: 'التاريخ', key: 'invoiceDate' },
//     { title: 'تاريخ الاستحقاق', key: 'dueDate' },
//     { title: 'المبلغ الأصلي', key: 'originalAmount' },
//     { title: 'الرصيد المتبقي', key: 'remainingAmount' },
//     { title: 'المبلغ المطبق', key: 'appliedAmount' },
//     { title: 'الرصيد بعد التطبيق', key: 'balanceAfter' }
//   ];

//   const getTableData = () => {
//     return transactions.map(invoice => {
//       const appliedItem = appliedTransactions.find(item => item.invoiceId === invoice.arReceiptScheduleId);
//       const appliedAmount = appliedItem?.amount || 0;
//       const remainingBalance = invoice.remainingAmount - appliedAmount;
//       const balanceAfter = Math.max(0, remainingBalance);

//       return {
//         invoiceNum: (
//           <div>
//             <div className='fw-bold'>{invoice.invoiceNum}</div>
//             <small className='text-muted'>دفع: {invoice.paymentNum}</small>
//           </div>
//         ),
//         invoiceDate: <div className='text-center'>{invoice.invoiceDate?.split('T')[0]}</div>,
//         dueDate: (
//           <div
//             className={`text-center ${new Date(invoice.dueDate) < new Date() ? 'text-danger fw-bold' : 'text-dark'}`}
//           >
//             {invoice.dueDate?.split('T')[0]}
//             {new Date(invoice.dueDate) < new Date() && (
//               <div>
//                 <small className='text-danger'>متأخرة</small>
//               </div>
//             )}
//           </div>
//         ),
//         originalAmount: <div className='text-center text-muted'>{Number(invoice.invoiceAmount).toLocaleString()}</div>,
//         remainingAmount: (
//           <div className={`text-center fw-bold ${invoice.remainingAmount > 0 ? 'text-primary' : 'text-success'}`}>
//             {Number(invoice.remainingAmount).toLocaleString()}
//           </div>
//         ),
//         appliedAmount: (
//           <div className='text-center'>
//             <Form.Control
//               type='number'
//               value={appliedAmount || ''}
//               onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
//                 const value = parseFloat(e.target.value) || 0;
//                 handleAppliedAmountChange(invoice.arReceiptScheduleId, value);
//               }}
//               onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
//                 const value = parseFloat(e.target.value) || 0;
//                 handleAppliedAmountChange(invoice.arReceiptScheduleId, value);
//               }}
//               step='0.01'
//               min='0'
//               max={Math.min(invoice.remainingAmount, selectedPrereceipt?.amountUnApply || 0)}
//               className='text-center fw-bold border-warning'
//               style={{ width: '130px' }}
//               placeholder='0'
//             />
//           </div>
//         ),
//         balanceAfter: (
//           <div className={`text-center fw-bold ${balanceAfter > 0 ? 'text-warning' : 'text-success'}`}>
//             {balanceAfter.toLocaleString()}
//             {balanceAfter === 0 && (
//               <div>
//                 <small className='text-success'>مستنفذ</small>
//               </div>
//             )}
//           </div>
//         )
//       };
//     });
//   };

//   // 🔹 مجموع المبالغ المطبقة على الفواتير القياسية
//   const totalAppliedAmount = appliedTransactions.reduce((sum, item) => sum + item.amount, 0);

//   // 🔹 المبلغ الكامل للدفعة المقدمة
//   const prepaymentTotal = selectedPrereceipt?.amount || 0;

//   // 🔹 المبلغ غير المطبق (المتبقي حالياً في النظام قبل التطبيق الجديد)
//   const prepaymentUnapplied = selectedPrereceipt?.amountUnApply || 0;

//   // 🔹 المبلغ المتبقي بعد التطبيق الحالي
//   const remainingPrepaymentAmount = prepaymentUnapplied - totalAppliedAmount;

//   // 🔹 التحقق من أن المستخدم لم يتجاوز المبلغ المتاح
//   const isAmountValid = totalAppliedAmount <= prepaymentUnapplied;

//   // 🔹 تحقق شامل من صلاحية النموذج
//   const isFormValid = !!selectedPrereceipt && appliedTransactions.length > 0 && isAmountValid;

//   console.log(transactions);
  
//   return (
//     <>
//       <div className='row g-3 mb-4'>
//         {/* العميل والوحدة التشغيلية */}
//         <div className='col-lg-5'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>العميل</label>
//             <TreeSelect
//               showSearch
//               className='w-100'
//               treeLine
//               placeholder='اختر العميل'
//               allowClear
//               value={values.peopleId}
//               onChange={option => {
//                 resetState();
//                 formik.setFieldValue('peopleId', option === null ? null : option);
//               }}
//               treeData={treeCustomerData}
//               treeNodeFilterProp='title'
//               getPopupContainer={triggerNode => triggerNode.parentNode}
//             />
//           </div>
//         </div>

//         <div className='col-lg-5'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>الوحدة التشغيلية</label>
//             <Select
//               isSearchable={true}
//               isClearable
//               options={OperatingUnitOptions}
//               value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
//               onChange={(option: any) => {
//                 resetState();
//                 setFieldValue('organizationId', option === null ? null : option.value);
//               }}
//               placeholder='اختر الوحدة التشغيلية'
//               className='react-select-container'
//               classNamePrefix='react-select'
//             />
//           </div>
//         </div>

//         <div className='col-lg-2'>
//           <div className='form-group h-100 d-flex flex-column justify-content-end'>
//             <button
//               disabled={isLoading || !values.organizationId || !values.peopleId}
//               type='button'
//               className='btn btn-sm btn-outline-theme w-100 py-2'
//               onClick={handleGetUnpaidTransactions}
//             >
//               {isLoading ? (
//                 <>
//                   <span className='spinner-border spinner-border-sm me-2'></span>
//                   جاري التحميل...
//                 </>
//               ) : (
//                 <>
//                   <i className='fas fa-download me-2'></i>
//                   جلب البيانات
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//       {fetchError && (
//         <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
//           <i className='fas fa-exclamation-triangle me-2'></i>
//           <div>{fetchError}</div>
//         </div>
//       )}
//       {/* الدفعات المقدمة */}
      
//       {preReceiptList.length > 0 && (
//         <div className='row mb-4'>
//           <div className='col-12'>
//             <Card className='border-warning'>
//               <CardHeader className='bg-warning bg-opacity-10 border-warning d-flex justify-content-between align-items-center py-3'>
//                 <h6 className='mb-0 '>
//                   <i className='fas fa-hand-holding-usd me-2 text-warning'></i>
//                   اختر الدفعة المقدمة
//                 </h6>
//                 <span className='badge bg-warning '>{preReceiptList.length} دفعة متاحة</span>
//               </CardHeader>

//               <CardBody className='p-0'>
//                 <div className='list-group list-group-flush'>
//                   {preReceiptList.map((item, index) => (
//                     <div
//                       key={item.id}
//                       className={`list-group-item list-group-item-action border-bottom ${
//                         selectedPrereceipt?.id === item.id
//                           ? ' bg-warning bg-opacity-10 border-warning border-1'
//                           : 'border-light'
//                       }`}
//                       onClick={() => handlePrepaymentSelection(item)}
//                       style={{ cursor: 'pointer', transition: 'all 0.2s' }}
//                     >
//                       <div className='d-flex justify-content-between align-items-start'>
//                         <div className='d-flex align-items-start flex-grow-1'>
//                           <div className='form-check mt-1 me-3'>
//                             <input
//                               type='radio'
//                               className='form-check-input'
//                               name='prepaymentInvoice'
//                               checked={selectedPrereceipt?.id === item.id}
//                               onChange={() => handlePrepaymentSelection(item)}
//                             />
//                           </div>
//                           <div className='flex-grow-1'>
//                             <div className='d-flex align-items-center mb-2'>
//                               <h6 className='mb-0 me-3'>{item.code}</h6>
//                               <span className='badge bg-light  small'>
//                                 <i className='fas fa-calendar me-1'></i>
//                                 {item.depositDate?.split('T')[0]}
//                               </span>
//                             </div>

//                             <div className='row g-3'>
//                               <div className='col-auto'>
//                                 <div className='d-flex flex-column'>
//                                   <small className='mb-1'>المبلغ الكامل</small>
//                                   <span className='fw-bold  fs-6'>
//                                     {Number(item.amount).toLocaleString()}
//                                   </span>
//                                 </div>
//                               </div>

//                               <div className='col-auto'>
//                                 <div className='vr h-100'></div>
//                               </div>

//                               <div className='col-auto'>
//                                 <div className='d-flex flex-column'>
//                                   <small className='text-muted mb-1'>المبلغ المتبقي</small>
//                                   <span className='fw-bold text-warning fs-6'>
//                                     {Number(item.amountUnApply).toLocaleString()}
//                                   </span>
//                                 </div>
//                               </div>

//                               <div className='col-auto'>
//                                 <div className='vr h-100'></div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>

//                         <div className='text-end ms-3'>
//                           <div className='d-flex flex-column align-items-end'>
//                             <span
//                               className={`badge fs-6 ${
//                                 selectedPrereceipt?.id === item.id ? 'bg-dark text-warning' : 'bg-warning '
//                               }`}
//                             >
//                               {Number(item.amountUnApply).toLocaleString()}
//                             </span>
//                             <small className='text-muted mt-1'>
//                               متبقي من {Number(item.amount).toLocaleString()}
//                             </small>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </CardBody>
//             </Card>
//           </div>
//         </div>
//       )}
//       {/* ملخص المقاصة */}
//       {(selectedPrereceipt || appliedTransactions.length > 0) && (
//         <div className={`alert ${isAmountValid ? 'alert-success' : 'alert-warning'} mb-4`}>
//           <div className='row text-center'>
//             <div className='col-md-3 border-end'>
//               <div className='small text-muted'>رصيد الدفعة المقدمة</div>
//               <div className='h5 fw-bold text-warning'>{prepaymentTotal.toLocaleString()}</div>
//               {selectedPrereceipt && <small className='text-muted'>دفعة: {selectedPrereceipt.code}</small>}
//             </div>
//             <div className='col-md-3 border-end'>
//               <div className='small text-muted'>المبلغ المطبق</div>
//               <div className='h5 fw-bold text-primary'>{totalAppliedAmount.toLocaleString()}</div>
//               <small className='text-muted'>على {appliedTransactions.length} فاتورة</small>
//             </div>
//             <div className='col-md-3 border-end'>
//               <div className='small text-muted'>الرصيد المتبقي</div>
//               <div className={`h5 fw-bold ${remainingPrepaymentAmount > 0 ? 'text-success' : 'text-danger'}`}>
//                 {remainingPrepaymentAmount.toLocaleString()}
//               </div>
//             </div>
//             <div className='col-md-3'>
//               <div className='small text-muted'>الحالة</div>
//               <div className={`h6 fw-bold ${isAmountValid ? 'text-success' : 'text-danger'}`}>
//                 {isAmountValid ? 'المبلغ ضمن الحدود' : 'المبلغ تجاوز الرصيد'}
//               </div>
//             </div>
//           </div>
//           {!isAmountValid && (
//             <div className='mt-2 text-center'>
//               <i className='fas fa-exclamation-triangle me-2'></i>
//               المبلغ المطبق لا يمكن أن يتجاوز رصيد الدفعة المقدمة
//             </div>
//           )}
//         </div>
//       )}

//       {/* جدول الفواتير العادية */}
//       {transactions.length > 0 && selectedPrereceipt && (
//         <div className='row'>
//           <div className='col-12'>
//             <Card className='border-primary'>
//               <CardHeader className='bg-primary bg-opacity-35 text-white d-flex justify-content-between align-items-center'>
//                 <h6 className='mb-0'>
//                   <i className='fas fa-file-invoice me-2'></i>
//                   الفواتير العادية - أدخل المبالغ المطبقة من الدفعة المقدمة
//                 </h6>
//               </CardHeader>
//               <CardBody className='p-0'>
//                 <div className='table-responsive'>
//                   <table className='table table-hover mb-0'>
//                     <thead className='table-primary'>
//                       <tr>
//                         {columns.map((col, index) => (
//                           <th key={index} className='text-center small'>
//                             {col.title}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {getTableData().map((row, rowIndex) => {
//                         const invoiceId = transactions[rowIndex]?.arReceiptScheduleId;
//                         const appliedItem = appliedTransactions.find(item => item.invoiceId === invoiceId);
//                         const appliedAmount = appliedItem?.amount || 0;

//                         return (
//                           <tr
//                             key={rowIndex}
//                             className={appliedAmount > 0 ? 'table-active bg-primary bg-opacity-10' : ''}
//                           >
//                             {columns.map((col, colIndex) => (
//                               <td key={colIndex} className='text-center align-middle'>
//                                 {row[col.key as keyof typeof row]}
//                               </td>
//                             ))}
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               </CardBody>
//               <CardFooter className='d-flex justify-content-between align-items-center'>
//                 <div className='text-muted small'>
//                   {appliedTransactions.length} / {transactions.length} فاتورة مختارة
//                 </div>
//                 <div className='fw-bold text-primary'>الإجمالي المطبق: {totalAppliedAmount.toLocaleString()}</div>
//               </CardFooter>
//             </Card>
//           </div>
//         </div>
//       )}
//       <div className='border-top mt-4 pt-4'>
//         <div className='d-flex justify-content-between align-items-center'>
//           <div></div>
//           <div className='d-flex'>
//             <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
//               <i className='fas fa-check-circle me-2'></i>
//               استمرار
//             </button>
//             <button
//               type='button'
//               className='btn btn-outline-secondary'
//               onClick={() => navigate('/Finance/Ar/ArReceipts', { replace: true })}
//             >
//               <i className='fas fa-times me-2'></i>
//               إلغاء
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };









 
// export const ApplyPreReceiptComponent: React.FC<{
//   formik: any;
//   onClose: () => void;
//   OperatingUnitOptions: any[];
//   treeCustomerData: any[];
// }> = ({ formik, onClose, OperatingUnitOptions, treeCustomerData }) => {
//   const { values, setFieldValue } = formik;
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   // State خاص بالمكون
//   const [preReceiptList, setPreReceiptList] = useState<any[]>([]);
//   const [transactions, setTransactions] = useState<any[]>([]);
//   const [selectedPrereceipt, setSelectedPrereceipt] = useState<any>(null);
//   const [appliedTransactions, setAppliedTransactions] = useState<Map<string, number>>(new Map());
//   const [isLoading, setIsLoading] = useState(false);
//   const [fetchError, setFetchError] = useState<string | null>(null);

//   const resetState = () => {
//     setPreReceiptList([]);
//     setTransactions([]);
//     setSelectedPrereceipt(null);
//     setAppliedTransactions(new Map());
//     setFetchError(null);
//     setIsLoading(false);
//   };

//   const handleGetUnpaidTransactions = async () => {
//     if (!values.organizationId || !values.peopleId) return;

//     setIsLoading(true);
//     setFetchError(null);

//     try {
//       const [prereceiptResult, standardResult] = await Promise.all([
//         dispatch(getUnApplyPrepaymentsListByPeopleId(values.peopleId)).unwrap(),
//         dispatch(
//           fetchUnpaidTransactions({
//             peopleId: values.peopleId,
//             organizationId: values.organizationId,
//             TransactionType: 'Standard'
//           })
//         ).unwrap()
//       ]);

//       let prereceiptData: any[] = [];
//       let standardData: any[] = [];
//       // debugger
//       if (prereceiptResult.succeeded) {
//         debugger
//         prereceiptData = prereceiptResult.data.map((item: any) => ({
//           amount: item.amount,
//           amountUnApply: item.amountUnApply,
//           code: item.code,
//           id: item.id,
//           depositDate: item.depositDate
//         }));
//         setPreReceiptList(prereceiptData);
//       }

//       if (standardResult.succeeded) {
//         standardData = standardResult.data.map((invoice: any) => ({
//           ...invoice,
//           invoiceType: 'Standard',
//           id: invoice.arReceiptScheduleId
//         }));
//         setTransactions(standardData);
//       }

//       if (!prereceiptResult.succeeded || prereceiptData.length === 0) {
//         setFetchError('لا توجد دفعات مقدمة للمقاصة');
//       } else if (!standardResult.succeeded || standardData.length === 0) {
//         setFetchError('لا توجد فواتير عادية للمقاصة');
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setFetchError('فشل في جلب البيانات');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handlePrepaymentSelection = (prepayment: any) => {
//     setSelectedPrereceipt(prepayment);
//   };

//   const handleAppliedAmountChange = (invoiceId: string, amount: number) => {
//     const invoice = transactions.find(inv => inv.arReceiptScheduleId === invoiceId);
//     if (!invoice) return;

//     const maxAmount = Math.min(invoice.remainingAmount, selectedPrereceipt?.amountUnApply || 0);
//     const finalAmount = Math.max(0, Math.min(amount, maxAmount));

//     const updatedApplied = new Map(appliedTransactions);

//     if (finalAmount > 0) {
//       updatedApplied.set(invoiceId, finalAmount);
//     } else {
//       updatedApplied.delete(invoiceId);
//     }

//     setAppliedTransactions(updatedApplied);
//   };

//   const handleSubmit = () => {
//     if (!selectedPrereceipt) {
//       alert('يجب اختيار دفعة مقدمة واحدة');
//       return;
//     }

//     if (appliedTransactions.size === 0) {
//       alert('يجب إدخال مبالغ للفواتير العادية');
//       return;
//     }

//     if (!isFormValid) {
//       return;
//     }

//     const totalAppliedAmount = Array.from(appliedTransactions.values()).reduce((sum, amount) => sum + amount, 0);
//     const prepaymentAmount = selectedPrereceipt.amountUnApply;

//     if (totalAppliedAmount > prepaymentAmount) {
//       alert(
//         `المبلغ الإجمالي المطبق (${totalAppliedAmount.toLocaleString()}) لا يمكن أن يتجاوز رصيد الدفعة المقدمة (${prepaymentAmount.toLocaleString()})`
//       );
//       return;
//     }

 

//     // إعداد بيانات الفواتير العادية (كهدف)
//     const appliedInvoicesData = Array.from(appliedTransactions.entries()).map(([scheduleId, appliedAmount]) => {
//       const invoice = transactions.find(inv => inv.arReceiptScheduleId === scheduleId);
//       return {
//         id: null,
//         arReceiptScheduleId: invoice.arReceiptScheduleId,
//         invoiceNum: invoice.invoiceNum,
//         invoiceDate: invoice.invoiceDate,
//         dueDate: invoice.dueDate,
//         invoiceAmount: invoice.invoiceAmount,
//         schadualAmount: invoice.schadualAmount || 0,
//         amount: appliedAmount,
//         actualRemainingAmount: invoice.remainingAmount,
//         invoiceType: 'Standard'
//       };
//     });

//     // const allInvoices = [prepaymentData, ...appliedInvoicesData];
//     // formik?.setFieldValue('scheduleList', allInvoices);

//     formik?.setFieldValue('scheduleList', appliedInvoicesData);
//     formik?.setFieldValue('prePaymentId', selectedPrereceipt.id);

//     // console.log(appliedInvoicesData);

//     onClose();
//   };

//   const columns = [
//     { title: 'رقم الفاتورة', key: 'invoiceNum' },
//     { title: 'التاريخ', key: 'invoiceDate' },
//     { title: 'تاريخ الاستحقاق', key: 'dueDate' },
//     { title: 'المبلغ الأصلي', key: 'originalAmount' },
//     { title: 'الرصيد المتبقي', key: 'remainingAmount' },
//     { title: 'المبلغ المطبق', key: 'appliedAmount' },
//     { title: 'الرصيد بعد التطبيق', key: 'balanceAfter' }
//   ];

//   const getTableData = () => {
//     return transactions.map(invoice => {
//       const appliedAmount = appliedTransactions.get(invoice.arReceiptScheduleId) || 0;
//       const remainingBalance = invoice.remainingAmount - appliedAmount;
//       const balanceAfter = Math.max(0, remainingBalance);

//       return {
//         invoiceNum: (
//           <div>
//             <div className='fw-bold'>{invoice.invoiceNum}</div>
//             <small className='text-muted'>دفع: {invoice.paymentNum}</small>
//           </div>
//         ),
//         invoiceDate: <div className='text-center'>{invoice.invoiceDate?.split('T')[0]}</div>,
//         dueDate: (
//           <div
//             className={`text-center ${new Date(invoice.dueDate) < new Date() ? 'text-danger fw-bold' : 'text-dark'}`}
//           >
//             {invoice.dueDate?.split('T')[0]}
//             {new Date(invoice.dueDate) < new Date() && (
//               <div>
//                 <small className='text-danger'>متأخرة</small>
//               </div>
//             )}
//           </div>
//         ),
//         originalAmount: <div className='text-center text-muted'>{Number(invoice.invoiceAmount).toLocaleString()}</div>,
//         remainingAmount: (
//           <div className={`text-center fw-bold ${invoice.remainingAmount > 0 ? 'text-primary' : 'text-success'}`}>
//             {Number(invoice.remainingAmount).toLocaleString()}
//           </div>
//         ),
//         appliedAmount: (
//           <div className='text-center'>
//             <Form.Control
//               type='number'
//               value={appliedAmount || ''}
//               onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
//                 const value = parseFloat(e.target.value) || 0;
//                 handleAppliedAmountChange(invoice.arReceiptScheduleId, value);
//               }}
//               onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
//                 const value = parseFloat(e.target.value) || 0;
//                 handleAppliedAmountChange(invoice.arReceiptScheduleId, value);
//               }}
//               step='0.01'
//               min='0'
//               max={Math.min(invoice.remainingAmount, selectedPrereceipt?.amountUnApply || 0)}
//               className='text-center fw-bold border-warning'
//               style={{ width: '130px' }}
//               placeholder='0'
//             />
//           </div>
//         ),
//         balanceAfter: (
//           <div className={`text-center fw-bold ${balanceAfter > 0 ? 'text-warning' : 'text-success'}`}>
//             {balanceAfter.toLocaleString()}
//             {balanceAfter === 0 && (
//               <div>
//                 <small className='text-success'>مستنفذ</small>
//               </div>
//             )}
//           </div>
//         )
//       };
//     });
//   };

//   // const totalAppliedAmount = Array.from(appliedStandardInvoices.values()).reduce((sum, amount) => sum + amount, 0);
//   // const totalPrepaymentAmount = selectedPrepayment ? selectedPrepayment.amountUnApply : 0;
//   // const remainingPrepaymentAmount = totalPrepaymentAmount - totalAppliedAmount;
//   // const isAmountValid = totalAppliedAmount <= totalPrepaymentAmount;
//   // const isFormValid = selectedPrepayment && appliedStandardInvoices.size > 0 && isAmountValid;

//   // 🔹 مجموع المبالغ المطبقة على الفواتير القياسية
//   const totalAppliedAmount = Array.from(appliedTransactions.values()).reduce((sum, amount) => sum + amount, 0);

//   // 🔹 المبلغ الكامل للدفعة المقدمة
//   const prepaymentTotal = selectedPrereceipt?.amount || 0;

//   // 🔹 المبلغ غير المطبق (المتبقي حالياً في النظام قبل التطبيق الجديد)
//   const prepaymentUnapplied = selectedPrereceipt?.amountUnApply || 0;

//   // 🔹 المبلغ المتبقي بعد التطبيق الحالي
//   // بمعنى: المبلغ غير المطبق - المبالغ الجديدة التي يريد المستخدم تطبيقها الآن
//   const remainingPrepaymentAmount = prepaymentUnapplied - totalAppliedAmount;

//   // 🔹 التحقق من أن المستخدم لم يتجاوز المبلغ المتاح
//   const isAmountValid = totalAppliedAmount <= prepaymentUnapplied;

//   // 🔹 تحقق شامل من صلاحية النموذج
//   const isFormValid = !!selectedPrereceipt && appliedTransactions.size > 0 && isAmountValid;


//   console.log(preReceiptList);
  
//   return (
//     <>
//       <div className='row g-3 mb-4'>
//         {/* العميل والوحدة التشغيلية */}
//         <div className='col-lg-5'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>العميل</label>
//             <TreeSelect
//               showSearch
//               className='w-100'
//               treeLine
//               placeholder='اختر العميل'
//               allowClear
//               value={values.peopleId}
//               onChange={option => {
//                 resetState();
//                 formik.setFieldValue('peopleId', option === null ? null : option);
//               }}
//               treeData={treeCustomerData}
//               treeNodeFilterProp='title'
//               getPopupContainer={triggerNode => triggerNode.parentNode}
//             />
//           </div>
//         </div>

//         <div className='col-lg-5'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>الوحدة التشغيلية</label>
//             <Select
//               isSearchable={true}
//               isClearable
//               options={OperatingUnitOptions}
//               value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
//               onChange={(option: any) => {
//                 resetState();
//                 setFieldValue('organizationId', option === null ? null : option.value);
//               }}
//               placeholder='اختر الوحدة التشغيلية'
//               className='react-select-container'
//               classNamePrefix='react-select'
//             />
//           </div>
//         </div>

//         <div className='col-lg-2'>
//           <div className='form-group h-100 d-flex flex-column justify-content-end'>
//             <button
//               disabled={isLoading || !values.organizationId || !values.peopleId}
//               type='button'
//               className='btn btn-sm btn-outline-theme w-100 py-2'
//               onClick={handleGetUnpaidTransactions}
//             >
//               {isLoading ? (
//                 <>
//                   <span className='spinner-border spinner-border-sm me-2'></span>
//                   جاري التحميل...
//                 </>
//               ) : (
//                 <>
//                   <i className='fas fa-download me-2'></i>
//                   جلب البيانات
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//       {fetchError && (
//         <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
//           <i className='fas fa-exclamation-triangle me-2'></i>
//           <div>{fetchError}</div>
//         </div>
//       )}
//       {/* الدفعات المقدمة */}
      
//       {preReceiptList.length > 0 && (
//         <div className='row mb-4'>
//           <div className='col-12'>
//             <Card className='border-warning'>
//               <CardHeader className='bg-warning bg-opacity-10 border-warning d-flex justify-content-between align-items-center py-3'>
//                 <h6 className='mb-0 '>
//                   <i className='fas fa-hand-holding-usd me-2 text-warning'></i>
//                   اختر الدفعة المقدمة
//                 </h6>
//                 <span className='badge bg-warning '>{preReceiptList.length} دفعة متاحة</span>
//               </CardHeader>

//               <CardBody className='p-0'>
//                 <div className='list-group list-group-flush'>
//                   {preReceiptList.map((item, index) => (
//                     <div
//                       key={item.id}
//                       className={`list-group-item list-group-item-action border-bottom ${
//                         selectedPrereceipt?.id === item.id
//                           ? ' bg-warning bg-opacity-10 border-warning border-1'
//                           : 'border-light'
//                       }`}
//                       onClick={() => handlePrepaymentSelection(item)}
//                       style={{ cursor: 'pointer', transition: 'all 0.2s' }}
//                     >
//                       <div className='d-flex justify-content-between align-items-start'>
//                         <div className='d-flex align-items-start flex-grow-1'>
//                           <div className='form-check mt-1 me-3'>
//                             <input
//                               type='radio'
//                               className='form-check-input'
//                               name='prepaymentInvoice'
//                               checked={selectedPrereceipt?.id === item.id}
//                               onChange={() => handlePrepaymentSelection(item)}
//                             />
//                           </div>
//                           <div className='flex-grow-1'>
//                             <div className='d-flex align-items-center mb-2'>
//                               <h6 className='mb-0 me-3'>{item.code}</h6>
//                               <span className='badge bg-light  small'>
//                                 <i className='fas fa-calendar me-1'></i>
//                                 {item.depositDate?.split('T')[0]}
//                               </span>
//                             </div>

//                             <div className='row g-3'>
//                               <div className='col-auto'>
//                                 <div className='d-flex flex-column'>
//                                   <small className='mb-1'>المبلغ الكامل</small>
//                                   <span className='fw-bold  fs-6'>
//                                     {Number(item.amount).toLocaleString()}
//                                     {/* <small className='text-muted ms-1'>ر.س</small> */}
//                                   </span>
//                                 </div>
//                               </div>

//                               <div className='col-auto'>
//                                 <div className='vr h-100'></div>
//                               </div>

//                               <div className='col-auto'>
//                                 <div className='d-flex flex-column'>
//                                   <small className='text-muted mb-1'>المبلغ المتبقي</small>
//                                   <span className='fw-bold text-warning fs-6'>
//                                     {Number(item.amountUnApply).toLocaleString()}
//                                     {/* <small className='text-muted ms-1'>ر.س</small> */}
//                                   </span>
//                                 </div>
//                               </div>

//                               <div className='col-auto'>
//                                 <div className='vr h-100'></div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>

//                         <div className='text-end ms-3'>
//                           <div className='d-flex flex-column align-items-end'>
//                             <span
//                               className={`badge fs-6 ${
//                                 selectedPrereceipt?.id === item.id ? 'bg-dark text-warning' : 'bg-warning '
//                               }`}
//                             >
//                               {Number(item.amountUnApply).toLocaleString()}
//                             </span>
//                             <small className='text-muted mt-1'>
//                               متبقي من {Number(item.amount).toLocaleString()}
//                             </small>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </CardBody>
//             </Card>
//           </div>
//         </div>
//       )}
//       {/* ملخص المقاصة */}
//       {(selectedPrereceipt || appliedTransactions.size > 0) && (
//         <div className={`alert ${isAmountValid ? 'alert-success' : 'alert-warning'} mb-4`}>
//           <div className='row text-center'>
//             <div className='col-md-3 border-end'>
//               <div className='small text-muted'>رصيد الدفعة المقدمة</div>
//               {/* <div className='h5 fw-bold text-warning'>{totalPrepaymentAmount.toLocaleString()}</div> */}
//               <div className='h5 fw-bold text-warning'>{prepaymentTotal.toLocaleString()}</div>
//               {selectedPrereceipt && <small className='text-muted'>دفعة: {selectedPrereceipt.code}</small>}
//             </div>
//             <div className='col-md-3 border-end'>
//               <div className='small text-muted'>المبلغ المطبق</div>
//               <div className='h5 fw-bold text-primary'>{totalAppliedAmount.toLocaleString()}</div>
//               <small className='text-muted'>على {appliedTransactions.size} فاتورة</small>
//             </div>
//             <div className='col-md-3 border-end'>
//               <div className='small text-muted'>الرصيد المتبقي</div>
//               <div className={`h5 fw-bold ${remainingPrepaymentAmount > 0 ? 'text-success' : 'text-danger'}`}>
//                 {remainingPrepaymentAmount.toLocaleString()}
//               </div>
//             </div>
//             <div className='col-md-3'>
//               <div className='small text-muted'>الحالة</div>
//               <div className={`h6 fw-bold ${isAmountValid ? 'text-success' : 'text-danger'}`}>
//                 {isAmountValid ? 'المبلغ ضمن الحدود' : 'المبلغ تجاوز الرصيد'}
//               </div>
//             </div>
//           </div>
//           {!isAmountValid && (
//             <div className='mt-2 text-center'>
//               <i className='fas fa-exclamation-triangle me-2'></i>
//               المبلغ المطبق لا يمكن أن يتجاوز رصيد الدفعة المقدمة
//             </div>
//           )}
//         </div>
//       )}
//       {/* جدول الفواتير العادية */}
//       {transactions.length > 0 && selectedPrereceipt && (
//         <div className='row'>
//           <div className='col-12'>
//             <Card className='border-primary'>
//               <CardHeader className='bg-primary bg-opacity-35 text-white d-flex justify-content-between align-items-center'>
//                 <h6 className='mb-0'>
//                   <i className='fas fa-file-invoice me-2'></i>
//                   الفواتير العادية - أدخل المبالغ المطبقة من الدفعة المقدمة
//                 </h6>
//               </CardHeader>
//               <CardBody className='p-0'>
//                 <div className='table-responsive'>
//                   <table className='table table-hover mb-0'>
//                     <thead className='table-primary'>
//                       <tr>
//                         {columns.map((col, index) => (
//                           <th key={index} className='text-center small'>
//                             {col.title}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {getTableData().map((row, rowIndex) => {
//                         const invoiceId = transactions[rowIndex]?.arReceiptScheduleId;
//                         const appliedAmount = appliedTransactions.get(invoiceId) || 0;

//                         return (
//                           <tr
//                             key={rowIndex}
//                             className={appliedAmount > 0 ? 'table-active bg-primary bg-opacity-10' : ''}
//                           >
//                             {columns.map((col, colIndex) => (
//                               <td key={colIndex} className='text-center align-middle'>
//                                 {row[col.key as keyof typeof row]}
//                               </td>
//                             ))}
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               </CardBody>
//               <CardFooter className='d-flex justify-content-between align-items-center'>
//                 <div className='text-muted small'>
//                   {appliedTransactions.size} / {transactions.length} فاتورة مختارة
//                 </div>
//                 <div className='fw-bold text-primary'>الإجمالي المطبق: {totalAppliedAmount.toLocaleString()}</div>
//               </CardFooter>
//             </Card>
//           </div>
//         </div>
//       )}
//       <div className='border-top mt-4 pt-4'>
//         <div className='d-flex justify-content-between align-items-center'>
//           <div></div>
//           <div className='d-flex'>
//             <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
//               <i className='fas fa-check-circle me-2'></i>
//               استمرار
//             </button>
//             <button
//               type='button'
//               className='btn btn-outline-secondary'
//               onClick={() => navigate('/Finance/Ar/ArReceipts', { replace: true })}
//             >
//               <i className='fas fa-times me-2'></i>
//               إلغاء
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };


 